import React from 'react'
import { CONST } from '../../utils/CONST'
import { useSelector } from 'react-redux'

export const VisaStatus = ({ status }: { status: number }) => {


    const user = useSelector((state) => (state as any).user.user)

    const lng = useSelector((state) => (state as any).common.lng)

    const isAdmin = user?.role_key === "super_admin"

    let find: any = isAdmin ? CONST.adminStatus.find((item: any) => {
        return item.id === status
    }) : CONST.agentStatus.find((item: any) => {
        return item.id === status
    })
    // text-green-200 bg-green-100
    return (
        <div className={`rounded-lg text-center py-2  text-xs lg:text-xs  w-full md:w-[86px]`} style={{color:find?.color ?? '#106103',backgroundColor: find?.bgColor ?? '#e9fde6'}}>
            {(find)?.[`${lng}`]}
        </div>
    )


}